const Unauthorized = () => (
  <div style={{ padding: "2rem", color: "red" }}>
    <h2>🚫 لا تملك صلاحية الوصول إلى هذه الصفحة</h2>
    <p>يرجى التواصل مع المدير لمنحك الصلاحية المناسبة.</p>
  </div>
);

export default Unauthorized;
